import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IGetReportFuncionarioTreinamentoUseCase } from "../../../presentation/useCases/read/get_report_funcionario_treinamento_use_case";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

import dayjs from "dayjs";
import { ReportData } from "../../models/report_data";

/**
 * GetReportFuncionarioTreinamentoUseCase
 */

export class GetReportFuncionarioTreinamentoUseCase implements IGetReportFuncionarioTreinamentoUseCase {
  constructor(
    private readonly repository: IReportsRepository,
  ) { }

  async getReportFuncionarioTreinamento(
    requiredMimeType: ReportMimeType | null,
    idAvaliacaoTreinamento: number,
    exibirConteudoProgramatico: number,
    instrutorAssinatura: number | null,
  ): Promise<ReportData> {
    const response = await this.repository.getRelatorioFuncionarioTreinamento(
      requiredMimeType,
      idAvaliacaoTreinamento,
      exibirConteudoProgramatico === 1,
      instrutorAssinatura,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `funcionario_treinamento_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}